// The editor body default moved 16px → 15px (commit 135ae9cf9) but the
// server-side engagementLetterTemplate is still authored at 16px, so generated
// paragraphs carry an explicit 16px fontSize mark while newly-typed text
// inherits the 15px body default — a visible non-uniformity.
//
// This strips ONLY the legacy body-default mark on load so generated text
// inherits the same 15px as new edits (and re-saves clean, without the mark).
// Any other explicit size (e.g. a 14px disclaimer, heading sizes) is intentional
// and preserved — the point is uniformity of BODY text, not flattening every
// size. Comparison is case/whitespace-insensitive and also accepts the numeric
// / unitless forms so a mark written as 16, '16', '16px', or ' 16PX ' all
// normalize. Immutable: builds new nodes, never mutates the input.

// The single legacy default we remove. The current body default is the
// inherited value once the mark is gone — see PlateEditor.module.scss `.content`
// and the shared `BODY_DEFAULT_FONT_SIZE_PX` constant (PlateEditor/bodyFontSize.ts)
// that FontSizeMenu's `DEFAULT_SIZE` reads. Keep these in lockstep.
const LEGACY_BODY_FONT_SIZE_PX = 16;

function isLegacyBodyFontSize(value: unknown): boolean {
    if (value == null) return false;
    if (typeof value === 'number') return value === LEGACY_BODY_FONT_SIZE_PX;
    if (typeof value === 'string') {
        const normalized = value.trim().toLowerCase().replace(/px$/, '').trim();
        return normalized === String(LEGACY_BODY_FONT_SIZE_PX);
    }
    return false;
}

export function normalizeLegacyBodyFontSize(node: any): any {
    if (Array.isArray(node)) return node.map(normalizeLegacyBodyFontSize);
    if (node && typeof node === 'object') {
        const out: any = {};
        for (const [key, value] of Object.entries(node)) {
            out[key] = normalizeLegacyBodyFontSize(value);
        }
        // Only strip from text leaves (nodes carrying a `text` string). Block
        // nodes never hold a body fontSize mark, and guarding on `text` avoids
        // touching any structural prop that might coincidentally be 16.
        if (typeof out.text === 'string' && isLegacyBodyFontSize(out.fontSize)) {
            delete out.fontSize;
        }
        return out;
    }
    return node;
}
